import React, { useContext, useEffect } from 'react'
import { AppSettings } from '../../config/app-settings'
import { toast } from 'react-toastify'
import { Card, CardBody } from '../other/card/card'
import { useCreateGuacamoleSessionMutation } from '../../redux/Api/UtilsApiSlice'

const GuacLogin = ({ onLoginSuccess }) => {
  const [createSession, { isLoading, isError, reset }] = useCreateGuacamoleSessionMutation()
  const context = useContext(AppSettings)

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)
  }, [context])

  useEffect(() => {
    const existingToken = localStorage.getItem('guac_token')
    if (existingToken) {
      onLoginSuccess()
    }
  }, [])

  const handleLogin = async () => {
    try {
      reset()
      const response = await createSession({}).unwrap()
      if (response?.token) {
        localStorage.setItem('guac_token', response.token)
        localStorage.setItem('guac_dataSource', response.data_source)
        onLoginSuccess()
      }
    } catch (err) {
      console.error('Guacamole session error:', err)
      toast.error('Failed to initialize RDP session')
    }
  }

  return (
    <div className='container-fluid'>
      <div className='row justify-content-center align-items-center' style={{ minHeight: '70vh' }}>
        <div className='col-md-6 col-lg-4'>
          <Card>
            <CardBody className='text-center'>
              <i className='fas fa-desktop fa-3x text-theme mb-3'></i>
              <h5 className='mb-1'>Remote Desktop</h5>
              <p className='text-muted mb-4'>Connect to your RDP session</p>
              {isError && (
                <p className='text-danger small mb-3'>
                  <i className='fas fa-exclamation-circle me-1'></i>
                  Failed to connect. Please try again.
                </p>
              )}
              <button
                className='btn btn-theme'
                onClick={handleLogin}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className='spinner-border spinner-border-sm me-2' role='status' />
                    Connecting...
                  </>
                ) : (
                  <>
                    <i className='fas fa-sign-in-alt me-2'></i>
                    Connect
                  </>
                )}
              </button>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default GuacLogin
